module.exports = __webpack_public_path__ + "img/nstp.761648ee.png";